import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1231.31354,481.451526 L1231.31354,618.264141 L684.063075,618.264141 L684.063075,1849.57768 L547.25046,1849.57768 L547.25046,618.264141 L0,618.264141 L0,481.451526 L1231.31354,481.451526 Z M1675.88613,71 C1774.52802,71 1865.91885,131.334363 1903.13188,221.220251 C1939.93448,310.148451 1915.71864,409.611222 1838.2827,487.047162 C1747.98638,577.343488 1625.26546,688.024894 1549.88171,755.063075 L1549.88171,755.063075 L1915.3082,755.063075 L1915.3082,891.87569 L1436.46405,891.87569 C1398.70377,891.87569 1368.05774,861.229665 1368.05774,823.469383 L1368.05774,823.469383 L1368.05774,763.545457 C1368.05774,743.844441 1376.67694,724.9643 1391.58951,711.967101 C1393.77852,710.051725 1608.02707,523.849756 1741.55618,390.320644 C1780.13734,351.739486 1792.31366,311.379765 1776.71703,273.48267 C1760.70995,234.7647 1719.25573,207.812615 1675.88613,207.812615 C1575.73929,207.812615 1492.00997,316.305019 1491.05229,317.536332 L1491.05229,317.536332 L1381.73901,235.175138 C1386.80107,228.47132 1506.92255,71 1675.88613,71 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextSuperscriptLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextSuperscriptLine, _Component);

  var _super = _createSuper(IconTextSuperscriptLine);

  function IconTextSuperscriptLine() {
    _classCallCheck(this, IconTextSuperscriptLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextSuperscriptLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextSuperscript",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextSuperscriptLine.displayName = "IconTextSuperscriptLine";
  return IconTextSuperscriptLine;
}(Component);

IconTextSuperscriptLine.glyphName = 'text-superscript';
IconTextSuperscriptLine.variant = 'Line';
IconTextSuperscriptLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextSuperscriptLine;
export { IconTextSuperscriptLine };